/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Text_To_Audio_Character_LabelInputs */

const en_dialog_text_to_audio_character_label = /** @type {(inputs: Dialog_Text_To_Audio_Character_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`character`)
};

const es_dialog_text_to_audio_character_label = /** @type {(inputs: Dialog_Text_To_Audio_Character_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`carácter`)
};

/**
* | output |
* | --- |
* | "character" |
*
* @param {Dialog_Text_To_Audio_Character_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_character_label = /** @type {((inputs?: Dialog_Text_To_Audio_Character_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Character_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_character_label(inputs)
	return en_dialog_text_to_audio_character_label(inputs)
});